export type VideoProperties = {
  width?: number;
  height?: number;
  duration?: number;
};

export const extractVideoProperties = async (url: string): Promise<VideoProperties> => {
  try {
    return await new Promise<VideoProperties>((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        resolve({ width: video.videoWidth, height: video.videoHeight, duration: video.duration });
      };

      video.onerror = (error) => {
        reject(error);
      };

      video.src = url;
    });
  } catch (error) {
    console.warn("Failed to extract video properties on upload", error);
  }
  return { width: undefined, height: undefined, duration: undefined };
};
